import getters from './getters'
import state from './state'
import mutations from './mutations'
import actions from './actions'

export const referral = {
  namespaced: true,
  actions,
  state,
  getters,
  mutations
}
